import { OneSettingT } from 'shared/api/types/services';
import ModelInfo, { InfoBoxesT } from 'shared/components/ModelInfo';

interface Props {
  data: OneSettingT['response'];
}

const Info = ({ data }: Props) => {
  const infoBoxes: InfoBoxesT = [
    {
      label: 'Key',
      type: 'text',
      value: data.key,
    },
    {
      label: 'Value',
      type: 'text',
      value: data.value,
    },
    {
      label: 'Description',
      type: 'text',
      value: data.description,
    },
  ]

  return (
    <ModelInfo infoBoxes={infoBoxes} />
  );
};

export default Info;
